import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Modal from "react-bootstrap/Modal";
import { getDate } from "utils/formatDate";
import choVayConst, { LaiSuatText2 } from "constants/choVayConst";
import { formatNumber } from "utils/currencyFormat";
import { pushNotification } from "utils/notifications";
import CamDoApi from "../../../../service/chiTietHopDongApi";
import TatToanChoDuyetApi from "../../../../service/tatToanChoDuyetApi";
// import {
//     getListTatToanChoDuyet,
//     updateDataSearch,
// } from "../../../../actions/DanhSachTatToanChoDuyet";
import { set } from "lodash";
const ThongTinDuyetTatToan = ({
  show,
  onHide,
  item,
  shopAdmin,
  SearchDanhSach,
}) => {
  const dispatch = useDispatch();
  // const listTatToanChoDuyetFull = useSelector(
  //     (state) => state.listTatToanChoDuyetFull
  // );
  const dataSearch = useSelector((state) => state.dataSearchTatToanChoDuyet);
  const [isAction, setIsAction] = useState(false);
  const [listTatToanChoDuyetFull, setListTatToanChoDuyetFull] = useState([]);
  const [hopDong, setHopDong] = useState([]);
  useEffect(() => {
    // CamDoApi.getChiTietHopDong1(item.ChoVayId).then((response) => {
    //     setHopDong(response.data);
    // });
  }, []);

  const initDuyetTaToan = {
    TatToanChoDuyetID: 0,
    GhiChu: "",
    BuocDuyet: 0,
    NguoiDuyet: "",
    TrangThai: 0,
  };
  const [dataDuyetTatToan, setDataDuyetTatToan] = useState(initDuyetTaToan);
  // const searchDanhSach = ()=>{
  //        TatToanChoDuyetApi.danhSachTatToanChoDuyet(dataDuyetTatToan).then((response) => {
  //         if (response.data.Error === 1) {
  //             pushNotification(response.data.Message, "error", "TOP_CENTER", 3000);
  //             setIsAction(false);
  //         }
  //         else {
  //             pushNotification(response.data.Message, "success", "TOP_CENTER", 3000);
  //             dispatch(getListTatToanChoDuyet(dataSearch));
  //             onHide();
  //         }
  //     });
  // }
  const onSubmit = () => {
    setIsAction(true);
    dataDuyetTatToan.TrangThai = 1;
    dataDuyetTatToan.TatToanChoDuyetID = item.TatToanChoDuyetID;
    dataDuyetTatToan.BuocDuyet = item.BuocDuyet;
    TatToanChoDuyetApi.duyetTatToan(dataDuyetTatToan).then((response) => {
      if (response.data.Error === 1) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 3000);
        setIsAction(false);
      } else {
        pushNotification(response.data.Message, "success", "TOP_CENTER", 3000);
        SearchDanhSach();
        onHide();
      }
    });
  };

  const onSubmitKhongDuyet = () => {
    setIsAction(true);
    dataDuyetTatToan.TrangThai = 2;
    dataDuyetTatToan.TatToanChoDuyetID = item.TatToanChoDuyetID;
    dataDuyetTatToan.BuocDuyet = item.BuocDuyet;
    TatToanChoDuyetApi.khongduyetTatToan(dataDuyetTatToan).then((response) => {
      if (response.data.Error === 1) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 3000);
        setIsAction(false);
      } else {
        pushNotification(response.data.Message, "success", "TOP_CENTER", 3000);
        SearchDanhSach();
        onHide();
      }
    });
  };

  const onSubmitTatToan = () => {
    setIsAction(true);
    dataDuyetTatToan.TrangThai = 1;
    dataDuyetTatToan.TatToanChoDuyetID = item.TatToanChoDuyetID;
    dataDuyetTatToan.BuocDuyet = item.BuocDuyet;
    TatToanChoDuyetApi.tatToanNgay(dataDuyetTatToan).then((response) => {
      if (response.data.Error === 1) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 3000);
        setIsAction(false);
      } else {
        pushNotification(response.data.Message, "success", "TOP_CENTER", 3000);
        SearchDanhSach();
        onHide();
      }
    });
  };

  const onChangeAttTextChoVay = (field) => (evt) => {
    setDataDuyetTatToan({
      ...dataDuyetTatToan,
      GhiChu: evt.target.value,
    });
  };

  return (
    <Modal
      show={show}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-clipboard-check"></i>
          </span>{" "}
          Duyệt tất toán hợp đồng
        </h4>
        <button type="button" className="close-popup-new" onClick={onHide}>
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="form-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="card collapse-icon accordion-icon-rotate">
                    <div
                      id="headingCollapse191"
                      className="card-header  mt-1"
                      data-toggle="collapse"
                      href="#collapse191"
                      aria-expanded="false"
                      aria-controls="collapse191"
                    >
                      <a
                        className="card-title lead info collapsed"
                        href={() => false}
                      >
                        <h3>Thông tin tất toán</h3>
                      </a>
                    </div>
                    <div
                      aria-labelledby="heading61"
                      className="card-collapse collapse show"
                      aria-expanded="true"
                    >
                      <div className="card-content">
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-6">
                              <ul className="list-detailHD">
                                <li>
                                  Hợp đồng: <b>{item.Code}</b>
                                </li>
                                <li>
                                  Người thanh toán: <b>{item.Name}</b>
                                </li>
                                <li>
                                  Ngày tất toán: <b>{getDate(item.Time)}</b>
                                </li>
                                <li>
                                  Người tạo: <b>{item.UserName}</b>
                                </li>
                              </ul>
                            </div>
                            <div className="col-md-6">
                              <ul className="list-detailHD">
                                <li>
                                  Số tiền tất toán:{" "}
                                  <b>{formatNumber(item.Value)}</b>
                                </li>
                                <li>
                                  Phí khác: <b>{formatNumber(item.OtherFee)}</b>
                                </li>
                                <li>
                                  Phí kho: <b>{formatNumber(item.PhiKho)}</b>
                                </li>
                                <li>
                                  Phí hàng kỳ:{" "}
                                  <b>{formatNumber(item.OtherFeeHangKy)}</b>
                                </li>
                                <li>
                                  Phí chạm đóng lại:{" "}
                                  <b>{formatNumber(item.PhiChamDongLai)}</b>
                                </li>
                                <li>
                                  Phí tất toán sớm:{" "}
                                  <b>{formatNumber(item.PhiTatToanSom)}</b>
                                </li>
                                <li>
                                  Phí tất toán chậm:{" "}
                                  <b>{formatNumber(item.PhiTatToanQuaHan)}</b>
                                </li>
                                <li>
                                  Tổng tiền tất toán:{" "}
                                  <b className="color-do-bold">
                                    {formatNumber(
                                      item.Value +
                                        item.OtherFee +
                                        item.OtherFeeHangKy +
                                        item.PhiChamDongLai +
                                        item.PhiTatToanSom +
                                        item.PhiTatToanQuaHan,
                                    )}
                                  </b>
                                </li>
                              </ul>
                            </div>
                            <div className="col-md-12">
                              <ul className="list-detailHD">
                                <li>
                                  Ghi chú :
                                  <textarea
                                    rows="3"
                                    className="form-control input-sm"
                                    name="Note"
                                    placeholder=""
                                    onChange={onChangeAttTextChoVay("GhiChu")}
                                  ></textarea>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        {!isAction && shopAdmin && (
          <button
            type="button"
            className="btn btn-new-main btn-checknew"
            onClick={onSubmitTatToan}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-clipboard-check"></i>
            </span>
            Tất toán ngay
          </button>
        )}
        {!isAction && (
          <>
            <button
              type="button"
              className="btn btn-new-main btn-checknew"
              onClick={onSubmit}
            >
              <span className="btn-icon-left">
                <i className="mdi mdi-clipboard-check"></i>
              </span>
              Xác nhận duyệt
            </button>
            <button
              type="button"
              className="btn btn-new-main btn-checknew"
              onClick={onSubmitKhongDuyet}
            >
              <span className="btn-icon-left">
                <i className="mdi mdi-clipboard-alert"></i>
              </span>
              Không duyệt
            </button>
            <button
              type="button"
              className="btn btn-new-main btn-closenew"
              onClick={onHide}
            >
              <span className="btn-icon-left">
                <i className="mdi mdi-close"></i>
              </span>
              Đóng
            </button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};
export default ThongTinDuyetTatToan;
